import { Stack, Switch, Typography } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { EmailOptionProps as Props } from './types';

export const EmailOption = memo(({ className, item }: Props) => {
  const [check, setCheck] = useState<boolean>(false);
  return (
    <Styled.Wrapper
      className={classnames('EmailOption', className)}
      sx={SX.root}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={SX.title}>{item.title}</Typography>
        <Switch disabled checked={check} onChange={() => setCheck(!check)} />
      </Stack>
      <Typography sx={SX.description}>{item.description}</Typography>
    </Styled.Wrapper>
  );
});

EmailOption.displayName = 'EmailOption';
